import { Component, Input } from '@angular/core';

@Component({ standalone: false,
  selector: 'app-tooltip-content',
  template: `
    <div class="tooltip-box" [ngStyle]="{ top: top, left: left }">
      <div class="tooltip-body">
        <div class="gray-text range">MPP Range <span class="white-text">
        {{ data.mppt_voltage_min }}-{{data.mppt_voltage_max}}
        </span>
        </div>
        <div class="row-tooltip">
          <div>Vmp &#64; {{data.ambient_temp_max_c}}°{{data.temperatureUnit}}</div> <div class="gray-text pl-3">(Max Temp)</div> <div class="right-most">{{ data.calcVMPMax }}</div>
        </div>
        <div class="row-tooltip">
          <div>Vmp &#64; {{data.staticTemperature}}°{{data.temperatureUnit}}</div> <div class="gray-text pl-3">(STC)</div> <div class="right-most">{{ data.calcVMPSTC }}</div>
        </div>
        <div class="row-tooltip">
          <div>Voc &#64; {{data.staticTemperature}}°{{data.temperatureUnit}}</div> <div class="gray-text pl-3">(STC)</div> <div class="right-most">{{ data.calcVOCSTC }}</div>
        </div>
        <div class="row-tooltip">
          <div>Voc &#64; {{data.ambient_temp_min_c}}°{{data.temperatureUnit}}</div> <div class="gray-text pl-3">(Min Temp)</div> <div class="right-most">{{ data.calcVOCMin }}</div>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .tooltip-box {
      position: fixed;
      background: #3D3D3E;
      color: #fff;
      padding: 12px;
      border-radius: 8px;
      font-size: 14px;
      box-shadow: 0px 2px 12px rgba(0,0,0,0.3);

      z-index: 1000;
      font-style: 'inter-regular';
      font-weight: 400;

        .tooltip-body {
          font-size: 10px;

          .gray-text {
            color: #8C8C8C;
          }

          .white-text {
            color: #FFFFFF;
          }

          .range {
            margin-bottom: 6px;
          }

          .row-tooltip {
            display: flex;
            margin: 4px 0;
            width: auto !important;
            justify-content: flex-end;
          }

          .right-most {
            margin-left: auto; /* Ensures the child is pushed to the right */
            padding-left: 20px;
          }

          .pl-3 {
            padding-left: 3px;
          }
        }
    }
  `]
})
export class TooltipContentComponent {
  @Input() data: any;
  @Input() top = '0px';
  @Input() left = '0px';
}
